import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { TeamPlanComponent, TeamPlanData } from './team-plan/team-plan.component';

@Injectable({
  providedIn: 'root'
})
export class TeamService {

  private changeSub = new Subject();

  constructor(
    private matDialog: MatDialog,
    private router: Router
  ) { }

  goToPlan(teamId: any) {
    this.router.navigate(['/date', teamId]);
  }

  openPlanDialog(
    team: any,
    order: any,
    sub: Subject<any>
  ): Observable<any> {
    return this.matDialog.open(
      TeamPlanComponent,
      {
        data: {
          team,
          order,
          sub
        } as TeamPlanData,
        maxHeight: '90vh',
        maxWidth: '92vw',
        width: '90vw',
        height: '82vh',
        position: {
          top: '10px'
        }

      }
    ).afterClosed();
  }

  signalTeamDeleted(team: any) {
    this.changeSub.next({
      type: 'deleted',
      team
    });
  }

  changes(): Observable<any> {
    return this.changeSub.asObservable();
  }
}
